<template>
  <nav-bar title="待检测任务钢瓶" />

  <Content :bottom="0">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.gsId">
        <div class="row">
          <span>气瓶编号：{{ item.gsId }}</span>
          <van-button
            type="primary"
            size="mini"
            @click="
              $router.push(`/editTaskCylinder/${item.cId}-${item.cMedium}`)
            "
            >编辑</van-button
          >
        </div>
        <div class="row">批次号： {{ item.batchNo }}</div>
        <div class="row">送检单位：{{ item.sendUnit }}</div>
      </li>
    </ul>
  </Content>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { getCheckInfoListForApp } from '@/api/cylinderManageUserHome'
const route = useRoute()
const data = JSON.parse(route.params.data)
const store = useStore()
const empId = computed(() => store.state.roleInfo.empId)
const companyId = computed(() => store.state.roleInfo.companyId)
const showLoading = ref(true)
const isLoading = ref(true)
const list = ref([])
const getList = () => {
  showLoading.value = true
  isLoading.value = true
  getCheckInfoListForApp({
    ...data,
    userId: empId.value,
    companyId: companyId.value
  })
    .then((res) => {
      console.log(res)
      list.value = res.data
      showLoading.value = false
    })
    .finally(() => {
      isLoading.value = false
    })
}
getList()
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    background-color: #fff;
    padding: 10px 16px;
    margin-top: 16px;
    border-radius: 5px;
    line-height: 26px;
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>
